import React from 'react';
import config from '../../_config';
import './style.css';

const DEFAULT_FEATURES = [
    'Free to download',
    'Instant alerts for new listings',
    'Save, search, and message on the go',
];

const DownloadAppSection = ({
    kicker = 'Go Mobile',
    title = 'Take Home Hunt with you',
    lead = 'Search thousands of listings, save your favourites, and chat with agents, right from your phone.',
    features = DEFAULT_FEATURES,
    imageSrc = '/assets/img/app-screenshot.png',
    imageAlt = 'Home Hunt Android app home screen',
    apkUrl = `${config.baseUrl}/public/apk/home-hunt.apk`,
}) => (
    <section className="dl-app-section widget_edit_enabled">
        <div className="container">
            <div className="dl-app-grid">
                <div className="dl-app-visual">
                    <div className="dl-app-phone">
                        <span className="dl-app-phone-notch" aria-hidden="true"></span>
                        <img
                            src={imageSrc}
                            alt={imageAlt}
                            className="dl-app-phone-img"
                        />
                    </div>
                </div>
                <div className="dl-app-content">
                    <span className="dl-app-kicker">{kicker}</span>
                    <h2 className="dl-app-title">{title}</h2>
                    <p className="dl-app-lead">{lead}</p>
                    <ul className="dl-app-list">
                        {features.map((feature, i) => (
                            <li className="dl-app-list-item" key={i}>
                                <i className="la la-check dl-app-check" aria-hidden="true"></i>
                                <span>{feature}</span>
                            </li>
                        ))}
                    </ul>
                    <a href={apkUrl} className="dl-app-btn" download>
                        <i className="la la-android dl-app-btn-icon" aria-hidden="true"></i>
                        <span className="dl-app-btn-text">
                            <small>Download the</small>
                            Android APK
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </section>
);

export default DownloadAppSection;
